import AuthBenefitsPackagePage from '../../containers/AuthBenefitsPackagePage';
import AuthRegistrationOnlyPage from '../../containers/AuthRegistrationOnlyPage';
import IdentityPage from '../../containers/IdentityPage';
import PersonalInformationPage from '../../containers/PersonalInformationPage';
import {
  includeRegOnlyAuthQuestions,
  isLoggedOut,
  showRegOnlyAuthConfirmation,
} from '../../utils/helpers';

export const additionalRoutes = [
  {
    path: 'id-form',
    pageKey: 'id-form',
    component: IdentityPage,
    depends: isLoggedOut,
  },
  {
    path: 'check-your-personal-information',
    pageKey: 'verify-personal-information',
    component: PersonalInformationPage,
    allowDirectAccess: false,
  },
  {
    path: 'va-benefits-package',
    pageKey: 'auth-va-benefits-package',
    component: AuthBenefitsPackagePage,
    depends: includeRegOnlyAuthQuestions,
    allowDirectAccess: false,
  },
  {
    path: 'care-for-service-connected-conditions',
    pageKey: 'auth-reg-only-confirmation',
    component: AuthRegistrationOnlyPage,
    depends: showRegOnlyAuthConfirmation,
    allowDirectAccess: false,
  },
];
